import * as React from 'react';
import { Hyperlink } from '../Hyperlink';
import styles from './animated_link.module.scss';
import { MaterialIcon } from '../material-icon/MaterialIcon';

interface IProps<T> {
  component: T;
}

export function AnimatedLink<T extends React.ReactType = typeof Hyperlink>({
  component,
  children,
  ...rest
}: OverwritableType<IProps<T>, T>) {
  const ElementType: React.ReactType = component;
  return (
    <ElementType {...rest} className={styles.container}>
      <span className={styles.title}>{children}</span>
      <span className={styles.icon}>
        <MaterialIcon name="arrow_forward" />
      </span>
    </ElementType>
  );
}

AnimatedLink.defaultProps = {
  component: Hyperlink,
};
